export const Permissions = {
  None: [0, 0x00000000],
  ApplicationUser: [0, 0x00000001],
  OrganizationRead: [0, 0x00000002],
  OrganizationUpdate: [0, 0x00000004],
  OrganizationDelete: [0, 0x00000008],
  OrganizationCreate: [0, 0x00000010],
  TokenAnonymous: [0, 0x00000020],
  TokenGet: [0, 0x00000040],
  TokenUpdate: [0, 0x00000080],
  TokenDelete: [0, 0x00000100],
  TokenCreate: [0, 0x00000200],
  AuthConnectionDiscover: [0, 0x00000400],
  AuthConnectionRead: [0, 0x00000800],
  AuthConnectionUpdate: [0, 0x00001000],
  AuthConnectionDelete: [0, 0x00002000],
  AuthConnectionCreate: [0, 0x00004000],
  PipelineCreate: [0, 0x00008000],
  PipelineRead: [0, 0x00010000],
  PipelineUpdate: [0, 0x00020000],
  PipelineDelete: [0, 0x00040000],
  PipelineExecute: [0, 0x00080000],
  WorkflowCreate: [0, 0x00100000],
  WorkflowRead: [0, 0x00200000],
  WorkflowUpdate: [0, 0x00400000],
  WorkflowDelete: [0, 0x00800000],
  DatasetCreate: [0, 0x01000000],
  DatasetRead: [0, 0x02000000],
  DatasetUpdate: [0, 0x04000000],
  DatasetDelete: [0, 0x08000000],
  LayerCreate: [0, 0x10000000],
  LayerRead: [0, 0x20000000],
  LayerUpdate: [0, 0x40000000],
  LayerDelete: [1, 0x00000001],
  MapCreate: [1, 0x00000002],
  MapRead: [1, 0x00000004],
  MapUpdate: [1, 0x00000008],
  MapDelete: [1, 0x00000010],
  DocumentRead: [1, 0x00000020],
  DocumentDelete: [1, 0x00000040],
  DocumentCreate: [1, 0x00000080],
  DocumentUpdate: [1, 0x00000100],
  UserProfileCreate: [1, 0x00000200],
  UserProfileRead: [1, 0x00000400],
  UserProfileUpdate: [1, 0x00000800],
  UserProfileDelete: [1, 0x00001000],
  UsersReadMyProfile: [1, 0x00002000],
  SecurityGroupCreate: [1, 0x00004000],
  SecurityGroupRead: [1, 0x00008000],
  SecurityGroupUpdate: [1, 0x00010000],
  SecurityGroupDelete: [1, 0x00020000],
  OrganizationSeeAll: [1, 0x00040000],
  DatasetShare: [1, 0x00080000],
  ChannelOrganizationAdmin: [1, 0x00100000],
  ChannelConfigCreate: [1, 0x00200000],
  ChannelConfigRead: [1, 0x00400000],
  ChannelConfigUpdate: [1, 0x00800000],
  ChannelConfigDelete: [1, 0x01000000],
  DistributionListCreate: [1, 0x02000000],
  DistributionListRead: [1, 0x04000000],
  DistributionListUpdate: [1, 0x08000000],
  DistributionListDelete: [1, 0x10000000],
  CommunicationTemplateCreate: [1, 0x20000000],
  CommunicationTemplateRead: [1, 0x40000000],
  CommunicationTemplateUpdate: [2, 0x00000001],
  CommunicationTemplateDelete: [2, 0x00000002],
  IncidentRead: [2, 0x00000008],
  ShareCommunications: [2, 0x00000400],
  AnalyticsRead: [2, 0x00010000],
  AnalyticsCreate: [2, 0x0008000],
  AnalyticsUpdate: [2, 0x0020000],
  AnalyticsDelete: [2, 0x0040000],
  OrganizationLinksCreate: [2, 0x00080000],
  OrganizationLinksRead: [2, 0x00100000],
  OrganizationLinksDelete: [2, 0x00200000],
  MassCommunicationsRead: [2, 0x00400000],
  CommunicationNotificationRead: [2, 0x02000000],
  CommunicationNotificationCreate: [2, 0x04000000],
  CommunicationNotificationUpdate: [2, 0x08000000],
  CommunicationNotificationDelete: [2, 0x10000000],
  RatingScalesRead: [2, 0x20000000],
  RatingScalesCreate: [2, 0x40000000],
  RatingScalesUpdate: [3, 0x00000001],
  RatingScalesDelete: [3, 0x00000002],
  IncidentCreate: [3, 0x00000004],
  IncidentUpdate: [3, 0x00000008],
  IncidentDelete: [3, 0x00000010],
  IncidentTaskRead: [3, 0x00000020],
  IncidentTaskCreate: [3, 0x00000040],
  IncidentTaskUpdate: [3, 0x00000080],
  IncidentTaskDelete: [3, 0x00000100]
};
